var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.184 0 0 1.184 -3.3132 -4.835)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18.956
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.41761 0 0 .41761 3.5309 5.5477)",
    d: "m11.537 18.957v13.256c0 4.7179 3.7978 8.5156 8.5156 8.5156h1.4746v3.5234h1.6172v5.75h3.7109v-5.75h1.6172v-3.5234h1.4746c4.7179 0 8.5156-3.7978 8.5156-8.5156v-13.256h-26.926zm17.178 2.6758h3.0625v4.7695h3.7305l-5.2637 9.1152-5.2637-9.1152h3.7344zm-8.959 0.0039 5.2637 9.1152h-3.7344v4.7676h-3.0625v-4.7676h-3.7305z",
    strokeWidth: 31.472
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.2031 2.6458c-0.69882 0-1.2608 0.56326-1.2608 1.2621v6.5723h10.573v-6.5723c0-0.69882-0.56194-1.2621-1.2608-1.2621h-8.0515zm0.66856 2.4636h1.374c0.25035 0 0.45273 0.20238 0.45273 0.45273v1.374c0 0.25035-0.20238 0.4514-0.45273 0.4514h-1.374c-0.25035 0-0.4514-0.20106-0.4514-0.4514v-1.374c0-0.25035 0.20106-0.45273 0.4514-0.45273zm5.3405 0h1.374c0.25035 0 0.4514 0.20238 0.4514 0.45273v1.374c0 0.25035-0.20106 0.4514-0.4514 0.4514h-1.374c-0.25035 0-0.45272-0.20106-0.45272-0.4514v-1.374c0-0.25035 0.20238-0.45273 0.45272-0.45273z",
    fill: "#fff",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24.019
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connected.7d7756213ea5aacf725c0957ab8e98b0.svg";